import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-rejection-dialog',
  templateUrl: './rejection-dialog.component.html',
  styleUrls: ['./rejection-dialog.component.scss']
})
export class RejectionDialogComponent implements OnInit {
    modalTitle ='Rejection Dialog';
    submitTitle = 'Reject';
    reason: string = '';
    @Input() id: number;
    @Input() buttonType: string;

    constructor(
      public dialogRef: MatDialogRef<RejectionDialogComponent>,
      public builder: FormBuilder, private store: Store,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.id = data.id;
    }

    ngOnInit(): void {
      this.modalTitle = this.data.modalTitle || this.modalTitle;
      this.submitTitle = this.data.submitTitle || this.submitTitle;
    }

    back(): void {
      this.dialogRef.close(false);
    }

    save(){
        this.dialogRef.close({reason: this.reason, result: true});
    }
  }
